import { render, staticRenderFns } from "./WhatIsAnIco.vue?vue&type=template&id=8896aae4&scoped=true&"
import script from "./WhatIsAnIco.vue?vue&type=script&lang=js&"
export * from "./WhatIsAnIco.vue?vue&type=script&lang=js&"
import style0 from "./WhatIsAnIco.vue?vue&type=style&index=0&id=8896aae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8896aae4",
  null
  
)

export default component.exports